const VisaPage = () => {
  return <div>Visa</div>;
};

export default VisaPage;
